module.exports = "/_next/static/images/ticketmaster_logo-2c30ee3c23f7c991122eddf737ebdff5.png";